<!-- インターバル時間内であればカメラ起動はできない -->
<template>
  <button disabled>次に使える時刻までお待ちください</button>
</template>

<script>
export default {
  name: "FaceInIntervalButton",
};
</script>

<style lang="scss" scoped>
button {
  position: absolute;
  bottom: 25%;
  width: 95%;
  height: 50px;
  border: none;
  border-radius: 30px;
  background-color: #ffb206;
  font-size: 14px;
  font-weight: bold;
  color: #000000;
  box-shadow: var(--defaultBoxShadow);
}

button:disabled {
  background-color: gray !important;
}
</style>
